// extracted by mini-css-extract-plugin
export default {"modal_root_width":"yearlyRecap_modal_root_width__Y-0k+","modal_root_height":"yearlyRecap_modal_root_height__JUCgH"};